module.exports = __webpack_public_path__ + "static/media/dateArrow.64d91e57.svg";